// adding some validations logic for automobile policies insurance form
import { required, email, minLength, numeric, between } from 'vuelidate/lib/validators'

export const FORM_AUTO_VALIDATIONS = {
  userDataForm: {
    name: {
      required,
      minLength: minLength(3)
    },
    address: {
      required,
      minLength: minLength(15)
    },
    country: {
      required,
      minLength: minLength(3)
    },
    zipcode: {
      required,
      numeric,
      minLength: minLength(5),
      between: between(10000, 99999)
    },
    phonenumber: {
      required,
      numeric,
      minLength: minLength(10)
    },
    email: {
      required,
      email
    },
    maritalstatus: {
      required
    },
    gender: {
      required
    },
    datebirth: {
      required,
      minLength: minLength(3)
    },
    datelicenced: {
      required,
      minLength: minLength(3)
    },
    licencenumber: {
      required,
      minLength: minLength(10)
    },
    vehicleidnumber: {
      required,
      minLength: minLength(10)
    },
    year: {
      required,
      numeric
    },
    make: {
      required
    },
    model: {
      required
    },
    annualmillage: {
      required,
      numeric
    },
    usage: {
      required
    }
  }
}



// WEBPACK FOOTER //
// ./src/validations/formAuto.js